import './app.css'
import axios from 'axios'
import { object, string } from 'yup'


document.addEventListener('DOMContentLoaded', () => {

    const vehicleOptions = document.querySelector(".vehicles-grid")

    const vehiclesList = [
        {
            name: "4Runner",
            image: "4Runner24",
        }, {
            name: "BZ4X",
            image: "BZ4X23",
        }, {
            name: "Camry",
            image: "Camry24",
        }, {
            name: "Corolla",
            image: "Corolla24"
        }, {
            name: "Corolla Cross",
            image: "CorollaCross24"
        }, {
            name: "Corolla Cross Hibrido",
            image: "CCrossHEV24"
        }, {
            name: "Corolla HB",
            image: "CorollaHB24"
        }, {
            name: "Crown",
            image: "Crown24"
        }, {
            name: "Crown Signia",
            image: "Signia25"
        }, {
            name: "Grand Highlander",
            image: "GHighlander24"
        }, {
            name: "Grand Highlander Hibrida",
            image: "GHighlanderHEV24"
        }, {
            name: "GR 86",
            image: "GR8624"
        }, {
            name: "GR Corolla",
            image: "GRCorolla24"
        }, {
            name: "GR Supra",
            image: "GRSupra24"
        }, {
            name: "Highlander",
            image: "Highlander24"
        }, {
            name: "Highlander Hibrida",
            image: "HighlanderHEV24"
        }, {
            name: "Land Cruiser",
            image: "LandCruiserEd24"
        }, {
            name: "Prius",
            image: "Prius24"
        }, {
            name: "Prius Prime",
            image: "PriusPrime24"
        }, {
            name: "RAV4",
            image: "RAV424"
        }, {
            name: "RAV4 Hibrida",
            image: "RAV4HEV24"
        }, {
            name: "RAV4 Prime",
            image: "RAV4Prime24"
        }, {
            name: "Sequoia",
            image: "Sequoia24"
        }, {
            name: "Sienna",
            image: "Sienna24"
        }, {
            name: "Tacoma",
            image: "Tacoma24"
        }, {
            name: "Tacoma Hibrida",
            image: "Tacoma24"
        }, {
            name: "Tundra",
            image: "Tundra24"
        }, {
            name: "Tundra Hibrida",
            image: "TundraHEV24"
        }, {
            name: "Venza",
            image: "Venza24"
        }, {
            name: "Otro",
            image: "otro"
        }
    ];

    vehiclesList.forEach(vehicle => {
        const slide = document.createElement("div")
        const image = document.createElement("img")
        const span = document.createElement("span")

        vehicleOptions.appendChild(slide)
        slide.classList.add("vehicle")

        slide.appendChild(image)
        image.src = `./images/${vehicle.image}.png`

        slide.appendChild(span)
        span.innerText = vehicle.name
    })

    const vehicles = document.querySelectorAll(".vehicle")

    vehicles.forEach(item => {
        item.addEventListener("click", () => {
            const span = item.querySelector("span")
            const input = document.querySelector("#vehicle")
            const otherFieldContainer = document.querySelector("#other-field")
            const otherInput = document.querySelector("#other")
            const isActive = item.classList.contains("active")
            const currentActive = item.parentElement.querySelector(".active")

            if (currentActive) currentActive.classList.remove("active")

            if (isActive) {
                item.classList.remove("active")
            } else {
                item.classList.add("active")
            }

            input.value = span.innerText

            if (input.id === "vehicle" && span.innerText === "Otro") {
                otherFieldContainer.classList.add("active")
                otherInput.value = ""

            } else {
                if (otherFieldContainer.classList.contains("active")) {
                    otherFieldContainer.classList.remove("active")
                    otherInput.value = "N/A"
                }
            }
        })
    })


    // FORM
    const form = document.getElementById("form")

    let schema = object({
        ffb: string().notRequired(),
        fname: string().required("Nombre requerido"),
        lname1: string().required("Primer apellido requerido"),
        lname2: string().required("Segundo apellido requerido"),
        phone: string().required("Teléfono requerido"),
        email: string().email("Formato de correo electrónico inválido").required("Correo electrónico requerido"),
        address: string().required("Dirección requerida"),
        town: string().required("Pueblo requerido"),
        zipcode: string().required("Código postal requerido"),
        service: string().required("Seleccione un servicio"),
        dealer: string().required("Seleccione un dealer"),
        vehicle: string().required("Modelo de vehículo requerido"),
        other: string().required("Debes especificar un vehículo"),
        news: string().notRequired()
    })

    const inputs = form.querySelectorAll(".input")

    inputs.forEach(input => {
        input.addEventListener("focus", () => {
            if (input.classList.contains = "error") {

                const label = input.nextElementSibling
                const labelDefaultString = label.dataset.defaultMessage

                label.innerHTML = labelDefaultString
                input.parentElement.classList.remove("error")
                input.classList.remove("error")
            }
        })
    })


    // PHONE MASK
    document.getElementById('phone').addEventListener('input', function (e) {
        const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    })


    // DROP DOWNS
    const towns = [
        "Aguada",
        "Aguadilla",
        "Aguas Buenas",
        "Aibonito",
        "Arecibo",
        "Arroyo",
        "Añasco",
        "Barceloneta",
        "Barranquitas",
        "Bayamón",
        "Cabo Rojo",
        "Caguas",
        "Camuy",
        "Canóvanas",
        "Carolina",
        "Cataño",
        "Cayey",
        "Ceiba",
        "Ciales",
        "Cidra",
        "Coamo",
        "Comerío",
        "Corozal",
        "Culebra",
        "Dorado",
        "Fajardo",
        "Florida",
        "Guayama",
        "Guayanilla",
        "Guaynabo",
        "Gurabo",
        "Guánica",
        "Hatillo",
        "Hormigueros",
        "Humacao",
        "Isabela",
        "Jayuya",
        "Juana Díaz",
        "Juncos",
        "Lajas",
        "Lares",
        "Las Marías",
        "Las Piedras",
        "Loiza",
        "Luquillo",
        "Manatí",
        "Maricao",
        "Maunabo",
        "Mayagüez",
        "Moca",
        "Morovis",
        "Naguabo",
        "Naranjito",
        "Orocovis",
        "Patillas",
        "Peñuelas",
        "Ponce",
        "Quebradillas",
        "Rincón",
        "Rio Grande",
        "Sabana Grande",
        "Salinas",
        "San Germán",
        "San Juan",
        "San Lorenzo",
        "San Sebastián",
        "Santa Isabel",
        "Toa Alta",
        "Toa Baja",
        "Trujillo Alto",
        "Utuado",
        "Vega Alta",
        "Vega Baja",
        "Vieques",
        "Villalba",
        "Yabucoa",
        "Yauco"
    ]

    const services = [
        "Coordinar cita en Centros de Servicio",
        "Coordinar un Test drive",
        "Comprar vehículo",
        "Información sobre Garantías",
        "Información sobre accesorios y piezas",
        "Información sobre vehículo"
    ];

    const dealerships = [
        "Adriel Auto Toyota",
        "Adriel Toyota Barranquitas",
        "Adriel Toyota Rio Grande",
        "Atlantic Toyota",
        "Autocentro",
        "Braulio Agosto",
        "Calesa Motors",
        "Furiel Bayamon",
        "Furiel Ponce",
        "Furiel Rio Piedras",
        "M.V.P. Toyota",
        "Naguabo Toyota",
        "Pepe Abad Auto",
        "Tocars Toyota Toa Baja",
        "Tocars Toyota Vega Baja",
        "Toyota Arecibo",
        "Toyota de Aguadilla",
        "Toyota de Bayamon",
        "Toyota del Oeste",
        "Toyota Monumental",
        "Toyota San Sebastian",
        "Triangle Toyota de San Juan"
    ];

    const dropdownTriggers = form.querySelectorAll(".dropdown-trigger")

    dropdownTriggers.forEach(trigger => {
        trigger.addEventListener("click", () => {

            const openDropdowns = form.querySelectorAll(".open")
            const isOpen = trigger.classList.contains("open")
            const input = trigger.parentElement.querySelector("input")
            const options = trigger.parentElement.querySelector(".dropdown-options")

            if (isOpen) {
                openDropdowns.forEach(openDropdown => openDropdown.classList.remove("open"))
                document.body.style.overflow = '';

            } else {
                openDropdowns.forEach(openDropdown => openDropdown.classList.remove("open"))
                document.body.style.overflow = 'hidden';
                trigger.classList.add("open")
                options.classList.add("open")
            }

        })
    })

    const townOptions = form.querySelector("#town-options")
    const serviceOptions = form.querySelector("#service-options")
    const dealerOptions = form.querySelector("#dealer-options")

    towns.forEach(town => {
        const li = document.createElement("li")
        li.innerText = town
        li.classList.add("option")
        townOptions.appendChild(li)
    })

    services.forEach(service => {
        const li = document.createElement("li")
        li.innerText = service
        li.classList.add("option")
        serviceOptions.appendChild(li)
    })

    dealerships.forEach(dealer => {
        const li = document.createElement("li")
        li.innerText = dealer
        li.classList.add("option")
        dealerOptions.appendChild(li)
    })

    const options = form.querySelectorAll(".option")

    options.forEach(li => {
        li.addEventListener("click", () => {
            const parent = li.parentElement
            const selected = parent.querySelector(".selected")
            const grandparent = parent.parentElement
            const input = grandparent.querySelector("input")
            const trigger = grandparent.querySelector(".dropdown-trigger")

            input.value = li.innerText

            if (selected) selected.classList.remove("selected")

            li.classList.add("selected")

            trigger.classList.remove("open")
            parent.classList.remove("open")
            document.body.style.overflow = '';
        })
    }
    )


    // SUBMIT
    form.addEventListener('submit', async (e) => {

        e.preventDefault()

        const modal = document.querySelector(".modal")
        const title = modal.querySelector("h2")
        const message = modal.querySelector("p")

        try {

            const formData = new FormData(form)
            const data = {}

            // Get honeypot value
            const ffb = formData.get("ffb")

            // Abort if honeypot is filled
            if (ffb !== "") return

            // Validate data
            await schema.validate(Object.fromEntries(formData), { abortEarly: false });

            // Build the formData
            formData.forEach((value, key) => (data[key] = value))

            // Submit the formData
            const response = await axios.post('https://saatchidev.com/verano-toyota/backend/submit.php', data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            title.innerHTML = response.data.title
            message.innerHTML = response.data.message

            modal.classList.add("active")

        } catch (error) {

            if (error.name === 'ValidationError') {
                error.inner.forEach(e => {

                    const input = form.querySelector(`#${e.path}`)
                    const label = form.querySelector(`[for=${e.path}]`)

                    label.innerHTML = e.message
                    input.parentElement.classList.add("error")
                    input.classList.add("error")
                })

            } else {
                console.error(error)
                title.innerHTML = "Error"
                message.innerHTML = error
                modal.classList.add("active")
            }
        }

    })


    // MODAL
    const modalClose = document.querySelector("#modal-close")
    modalClose.addEventListener("click", () => {

        const modal = document.querySelector(".modal")
        modal.classList.remove("active")

    })
})